import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface DispatchBarChartDataInterface {
  partnerCodes?: any
  fulfillmentOrderTypes?: any
  fromDate?: any
  toDate?: any
}

export const useGetDispatchBarChartData = () => {
  const mutate = useMutation(
    ({
      partnerCodes,
      fulfillmentOrderTypes,
      fromDate,
      toDate,
    }: DispatchBarChartDataInterface) => {
      return postAPI(`MWDashboard/GetBarChartDetails`, {
        partnerCodes: partnerCodes || [],
        fulfillmentOrderTypes: fulfillmentOrderTypes || [],
        fromDate: fromDate || '',
        toDate: toDate || '',
      })
    },
  )

  return mutate
}

export default useGetDispatchBarChartData
